export interface ConfigDto {
    about_app: string;
    astrologist_avatar: string;
    astrologist_description: string;
    astrologist_name: string;
    choose_deck_screen_description_no_sub: string;
    choose_deck_screen_description_subscribed: string;
    christmas_card_enabled: boolean;
    default_or_event_card: string;
    event_card_description: string;
    event_card_name: string;
    isDebug: boolean;
    month_3_price: string;
    month_6_price: string;
    month_price: string;
    year_price: string;
}

export interface ConfigDomain {
    aboutApp: string;
    astrologistAvatar: string;
    astrologistDescription: string;
    astrologistName: string;
    chooseDeckScreenDescriptionNoSub: string;
    chooseDeckScreenDescriptionSubscribed: string;
    christmasCardEnabled: boolean;
    defaultOrEventCard: string;
    eventCardDescription: string;
    eventCardName: string;
    isDebug: boolean;
    month3Price: string;
    month6Price: string;
    monthPrice: string;
    yearPrice: string;
}

export const mapConfigDtoToDomain = (dto: ConfigDto): ConfigDomain => {
    return {
        aboutApp: dto.about_app,
        astrologistAvatar: dto.astrologist_avatar,
        astrologistDescription: dto.astrologist_description,
        astrologistName: dto.astrologist_name,
        chooseDeckScreenDescriptionNoSub: dto.choose_deck_screen_description_no_sub,
        chooseDeckScreenDescriptionSubscribed: dto.choose_deck_screen_description_subscribed,
        christmasCardEnabled: dto.christmas_card_enabled,
        defaultOrEventCard: dto.default_or_event_card,
        eventCardDescription: dto.event_card_description,
        eventCardName: dto.event_card_name,
        isDebug: dto.isDebug,
        month3Price: dto.month_3_price,
        month6Price: dto.month_6_price,
        monthPrice: dto.month_price,
        yearPrice: dto.year_price,
    }
}

export const mapConfigDomainToDto = (domain: ConfigDomain): ConfigDto => {
    return {
        about_app: domain.aboutApp,
        astrologist_avatar: domain.astrologistAvatar,
        astrologist_description: domain.astrologistDescription,
        astrologist_name: domain.astrologistName,
        choose_deck_screen_description_no_sub: domain.chooseDeckScreenDescriptionNoSub,
        choose_deck_screen_description_subscribed: domain.chooseDeckScreenDescriptionSubscribed,
        christmas_card_enabled: domain.christmasCardEnabled,
        default_or_event_card: domain.defaultOrEventCard,
        event_card_description: domain.eventCardDescription,
        event_card_name: domain.eventCardName,
        isDebug: domain.isDebug,
        month_3_price: domain.month3Price,
        month_6_price: domain.month6Price,
        month_price: domain.monthPrice,
        year_price: domain.yearPrice,
    }
}
